import { schema } from 'normalizr'
import $axios from '@/axiosInstance.js'
import {isEmpty} from 'lodash'
import Vue from 'vue'

//const user = new schema.Entity('users');

export default {
	namespaced: true,
	state: {
		order: {
			'area':{},
			'area_dates': {},
			'area_files': {},
			'area_comments':{},
			'retgen_comments':{},
			'area_comments_required':{},
			'retgen_comments_required':{},
			'phase':{},
			'carports':{},
			'first_fix':{},
			'wire':{},
			'tools':{},
			'specialarea':{},
			'final_fix':{},
			'units':{},
			'final_fix_general':{},
			'common':{}
		}
	},
	mutations: {
		addArea (state, payload) {
			if(!state.order.area[payload.phaseId])
			{
				Vue.set(state.order.area, payload.phaseId, payload.areaId.toString())
			}
			else 
			{
				let val = state.order.area[payload.phaseId]+'|-|'+payload.areaId
				// console.log(val);

				state.order.area[payload.phaseId] = val
			}
			
		},
		removeArea (state, payload) {
			
			let areaArr = state.order.area[payload.phaseId].split("|-|")
			let newstr = ''
			areaArr.forEach(areaid => {
				if(areaid != payload.areaId)
				{
					if(newstr === '')
					{
						newstr = areaid
					}
					else 
					{
						newstr = newstr+'|-|'+areaid
					}
				}
			});
			if(newstr === '')
			{
				Vue.delete(state.order.area, payload.phaseId)
			}
			else 
			{
				Vue.set(state.order.area, payload.phaseId, newstr)
			}
		},
		addPhase (state, payload) {
			Vue.set(state.order.phase, payload.phaseId, payload.products)
		},
		removePhase (state, payload) {
			Vue.delete(state.order.phase, payload.phaseId)
		},
		addFinalFix (state, payload) {
			if(!state.order.final_fix[payload.blockId])
			{
				Vue.set(state.order.final_fix, payload.blockId, payload.unitId.toString())
			}
			else 
			{
				let val = state.order.final_fix[payload.blockId]+'|-|'+payload.unitId

				Vue.set(state.order.final_fix, payload.blockId, val)
			}
			
		},
		removeFinalFix (state, payload) {
			let unitArr = state.order.final_fix[payload.blockId].split("|-|")
			let newstr = ''
			unitArr.forEach(unitid => {
				if(unitid != payload.unitId)
				{
					if(newstr === '')
					{
						newstr = unitid
					}
					else 
					{
						newstr = newstr+'|-|'+unitid
					}
				}
			});
			if(newstr === '')
			{
				Vue.delete(state.order.final_fix, payload.blockId)
			}
			else 
			{
				Vue.set(state.order.final_fix, payload.blockId, newstr)
			}
			
		},
		addUnit (state, payload) {
			
			Vue.set(state.order.units, payload.unitId, []);
			Object.keys(payload.products).forEach(pdt => {
				if(payload.products[pdt]){
					state.order.units[payload.unitId].push({[pdt]:payload.products[pdt]});
				}
			});
		},
		removeUnit (state, payload) {
			Vue.delete(state.order.units, payload.unitId)
		},
		addFinalFixGeneral (state, payload) {
			Vue.set(state.order.final_fix_general, payload.blockId, payload.products)
		},
		removeFinalFixGeneral (state, payload) {
			Vue.delete(state.order.final_fix_general, payload.blockId)
		},
		modifyWire (state, payload) {
			if(payload.qty<=0 || payload.qty==''){
				var c = 0
				if(payload.type == 'RetGen')
				{
					state.order.phase[payload.phaseId].forEach(pdt => {
						if(pdt[payload.productId])
						{
							Vue.delete(state.order.phase[payload.phaseId][c], payload.productId)
						}
						c++
					});
				}
				if(payload.type == 'Wire')
				{
					state.order.wire[payload.blockId].forEach(pdt => {
						if(pdt[payload.productId])
						{
							Vue.delete(state.order.wire[payload.blockId][c], payload.productId)
						}
						c++
					});
				}
				if(payload.type == 'Tools')
				{
					state.order.tools[payload.blockId].forEach(pdt => {
						if(pdt[payload.productId])
						{
							Vue.delete(state.order.tools[payload.blockId][c], payload.productId)
						}
						c++
					});
				}
			}else{

				if(payload.type == 'RetGen')
				{
					if(state.order.phase[payload.phaseId] == undefined)
					{
						Vue.set(state.order.phase, payload.phaseId, [{[payload.productId]:payload.qty }])
					}
					else 
					{
						var i = 0
						state.order.phase[payload.phaseId].forEach(pdt => {
							if(pdt[payload.productId])
							{
								Vue.delete(state.order.phase[payload.phaseId][i], payload.productId)
							}
							i++
						});
						Vue.set(state.order.phase[payload.phaseId], state.order.phase[payload.phaseId].length, {[payload.productId]:payload.qty })
					}
				}

				if(payload.type == 'Wire')
				{
					if(state.order.wire[payload.blockId] == undefined)
					{
						Vue.set(state.order.wire, payload.blockId, [{[payload.productId]:payload.qty }])
					}
					else 
					{
						var i = 0
						state.order.wire[payload.blockId].forEach(pdt => {
							if(pdt[payload.productId])
							{
								Vue.delete(state.order.wire[payload.blockId][c], payload.productId)
							}
							i++
						});

						Vue.set(state.order.wire[payload.phaseId], state.order.wire[payload.blockId].length, { [payload.productId]:payload.qty })
					}
				}

				if(payload.type == 'Tools')
				{
					if(state.order.tools[payload.blockId] == undefined)
					{
						Vue.set(state.order.tools, payload.blockId, [{[payload.productId]:payload.qty }])
					}
					else 
					{
						var i = 0
						state.order.tools[payload.blockId].forEach(pdt => {
							if(pdt[payload.productId])
							{
								Vue.delete(state.order.tools[payload.blockId][c], payload.productId)
							}
							i++
						});
						Vue.set(state.order.tools[payload.phaseId], state.order.tools[payload.blockId].length, { [payload.productId]:payload.qty })
					}
				}
			}
		},
		modifyProductQty (state, payload) {
			if(payload.qty<=0 || payload.qty==''){
				if(payload.type == 'RetGen')
				{
					if(state.order.phase[payload.phaseId]){
						state.order.phase[payload.phaseId].forEach((pdt, i) => {
							if(pdt[payload.productId])
							{
								state.order.phase[payload.phaseId].splice(i, 1);
								if(!state.order.phase[payload.phaseId].length){
									state.order.phase = {};
								}
							}
						});
					}
				}
				if(payload.type == 'Carports')
				{
					if(state.order.carports[payload.phaseId]){
						state.order.carports[payload.phaseId].forEach((pdt, i) => {
							if(pdt[payload.productId])
							{
								state.order.carports[payload.phaseId].splice(i, 1);
								if(!state.order.carports[payload.phaseId].length){
									state.order.carports = {};
								}
							}
						});
					}
				}
				if(payload.type == 'FirstFix')
				{
					state.order.first_fix[payload.blockId].forEach((pdt, i) => {
						if(pdt[payload.productId]) {
							if(pdt['floor'] == payload.floor){
								state.order.first_fix[payload.blockId].splice(i, 1);
							}
						}
					});
					if(!state.order.first_fix[payload.blockId].length){
						Vue.delete(state.order.first_fix, payload.blockId);
					}
				}
				if(payload.type == 'Wire')
				{
					if(state.order.wire[payload.blockId]){
						state.order.wire[payload.blockId].forEach((pdt, i) => {
							if(pdt[payload.productId])
							{
								state.order.wire[payload.blockId].splice(i, 1);
								if(!state.order.wire[payload.blockId].length){
									state.order.wire = {};
								}
							}
						});
					}
				}
				if(payload.type == 'Unit')
				{
					// if(state.order.units[payload.unitId] && state.order.units[payload.unitId][payload.productId]){
					// 	Vue.delete(state.order.units[payload.unitId], payload.productId);
					// 	if(isEmpty(state.order.units[payload.unitId])){
					// 		Vue.delete(state.order.units, payload.unitId);							
					// 	}
					// }
					if(state.order.units[payload.unitId]){
						state.order.units[payload.unitId].forEach((pdt, i) => {
							if(pdt[payload.productId])
							{
								state.order.units[payload.unitId].splice(i, 1);
								if(!state.order.units[payload.unitId].length){
									state.order.units = {};
								}
							}
						});
					}
				}
				if(payload.type == 'Tools')
				{
					if(state.order.tools[payload.jobId]){
						state.order.tools[payload.jobId].forEach((pdt, i) => {
							if(pdt[payload.productId])
							{
								state.order.tools[payload.jobId].splice(i, 1);
								if(!state.order.tools[payload.jobId].length){
									state.order.tools = {};
								}
							}
						});
					}
				}
				if(payload.type == 'Specialarea')
				{
					if(state.order.specialarea[payload.areaId]){
						state.order.specialarea[payload.areaId].forEach((pdt, i) => {
							if(pdt[payload.productId])
							{
								state.order.specialarea[payload.areaId].splice(i, 1);
								if(!state.order.specialarea[payload.areaId].length){
									state.order.specialarea = {};
								}
							}
						});
					}
				}
				if(payload.type == 'FinalFixGen')
				{
					if(state.order.final_fix_general[payload.blockId]){
						state.order.final_fix_general[payload.blockId].forEach((pdt, i) => {
							if(pdt[payload.productId])
							{
								state.order.final_fix_general[payload.blockId].splice(i, 1);
								if(!state.order.final_fix_general[payload.blockId].length){
									state.order.final_fix_general = {};
								}
							}
						});
					}
				}
				if(payload.type == 'Common')
				{
					if(state.order.common[payload.blockId]){
						state.order.common[payload.blockId].forEach((pdt, i) => {
							if(pdt[payload.productId])
							{
								state.order.common[payload.blockId].splice(i, 1);
								if(!state.order.common[payload.blockId].length){
									state.order.common = {};
								}
							}
						});
					}
				}
			}else{

				if(payload.type == 'RetGen')
				{
					if(state.order.phase[payload.phaseId] == undefined)
					{
						Vue.set(state.order.phase, payload.phaseId, [{[payload.productId]:payload.qty }])
					}
					else 
					{
						state.order.phase[payload.phaseId].forEach((pdt,i) => {
							if(pdt[payload.productId])
							{
								state.order.phase[payload.phaseId].splice(i, 1);
							}
						});
						state.order.phase[payload.phaseId].push({
							[payload.productId]:payload.qty
						})
					}
				}
				if(payload.type == 'Carports')
				{
					if(state.order.carports[payload.phaseId] == undefined)
					{
						Vue.set(state.order.carports, payload.phaseId, [{[payload.productId]:payload.qty }])
					}
					else 
					{
						state.order.carports[payload.phaseId].forEach((pdt,i) => {
							if(pdt[payload.productId])
							{
								state.order.carports[payload.phaseId].splice(i, 1);
							}
						});
						state.order.carports[payload.phaseId].push({
							[payload.productId]:payload.qty
						})
					}
				}
				if(payload.type == 'FirstFix')
				{
					if(state.order.first_fix[payload.blockId] == undefined)
					{
						Vue.set(state.order.first_fix, payload.blockId, [
							{
								[payload.productId]:payload.qty,
								floor: payload.floor
							}
						])
					}
					else 
					{
						state.order.first_fix[payload.blockId].forEach((pdt, i) => {
							if(pdt[payload.productId]) {
								if(pdt['floor'] == payload.floor){
									state.order.first_fix[payload.blockId].splice(i, 1);									
								}
							}
						});
						state.order.first_fix[payload.blockId].push({
							[payload.productId]:payload.qty,
							floor: payload.floor
						});
					}
				}
				if(payload.type == 'Wire')
				{
					if(state.order.wire[payload.blockId] == undefined)
					{
						Vue.set(state.order.wire, payload.blockId, [{[payload.productId]:payload.qty }])
					}
					else 
					{
						state.order.wire[payload.blockId].forEach((pdt, i) => {
							if(pdt[payload.productId])
							{
								state.order.wire[payload.blockId].splice(i, 1);
							}
						});
						state.order.wire[payload.blockId].push({
							[payload.productId]:payload.qty
						});
					}
				}
				if(payload.type == 'Unit')
				{
					if(state.order.units[payload.unitId] == undefined)
					{
						Vue.set(state.order.units, payload.unitId, [{[payload.productId]:payload.qty }])
					}
					else 
					{
						state.order.units[payload.unitId].forEach((pdt, i) => {
							if(pdt[payload.productId])
							{
								state.order.units[payload.unitId].splice(i, 1);
							}
						});
						state.order.units[payload.unitId].push({
							[payload.productId]:payload.qty
						});
					}
				}
				if(payload.type == 'Tools')
				{
					if(state.order.tools[payload.jobId] == undefined)
					{
						Vue.set(state.order.tools, payload.jobId, [{[payload.productId]:payload.qty }])
					}
					else 
					{
						state.order.tools[payload.jobId].forEach((pdt, i) => {
							if(pdt[payload.productId])
							{
								state.order.tools[payload.jobId].splice(i, 1);
							}
						});
						state.order.tools[payload.jobId].push({
							[payload.productId]:payload.qty
						});
					}
				}
				if(payload.type == 'Specialarea')
				{
					if(state.order.specialarea[payload.areaId] == undefined)
					{
						Vue.set(state.order.specialarea, payload.areaId, [{[payload.productId]:payload.qty }])
					}
					else 
					{
						state.order.specialarea[payload.areaId].forEach((pdt, i) => {
							if(pdt[payload.productId])
							{
								state.order.specialarea[payload.areaId].splice(i, 1);
							}
						});
						state.order.specialarea[payload.areaId].push({
							[payload.productId]:payload.qty
						});
					}
				}
				if(payload.type == 'FinalFixGen')
				{
					if(state.order.final_fix_general[payload.blockId] == undefined)
					{
						Vue.set(state.order.final_fix_general, payload.blockId, [{[payload.productId]:payload.qty }])
					}
					else 
					{
						state.order.final_fix_general[payload.blockId].forEach((pdt,i) => {
							if(pdt[payload.productId])
							{
								state.order.final_fix_general[payload.blockId].splice(i, 1);
							}
						});
						state.order.final_fix_general[payload.blockId].push({
							[payload.productId]:payload.qty
						});
					}
				}
				if(payload.type == 'Common')
				{
					console.log(payload);
					if(state.order.common[payload.blockId] == undefined)
					{
						Vue.set(state.order.common, payload.blockId, [{[payload.productId]:payload.qty }])
					}
					else 
					{
						state.order.common[payload.blockId].forEach((pdt,i) => {
							if(pdt[payload.productId])
							{
								state.order.common[payload.blockId].splice(i, 1);
							}
						});
						state.order.common[payload.blockId].push({
							[payload.productId]:payload.qty
						});
					}
				}
			}
		},
		addAreaFile (state, payload) {
			Vue.set(state.order.area_files, payload.areaId, payload.file)
		},
		removeAreaFile (state, payload) {
			Vue.delete(state.order.area_files, payload.areaId)
		},
		modifyAreaProductQty (state, payload) {
			
			if((payload.qty<=0 || payload.qty=='') && state.order.area[payload.areaId]){
				state.order.area[payload.areaId].forEach((pdt, i) => {
					if(pdt[payload.productId])
					{
						state.order.area[payload.areaId].splice(i, 1);
						if(!state.order.area[payload.areaId].length){
							state.order.area = {};
							state.order.area_dates = {};
						}
					}
				});

			}else{
				if(state.order.area[payload.areaId] == undefined)
				{
					Vue.set(state.order.area, payload.areaId, [{ [payload.productId]:payload.qty }])
					Vue.set(state.order.area_dates, payload.areaId, [{ [payload.productId]:payload.areaDate }])
				}
				else 
				{
					state.order.area[payload.areaId].forEach((pdt, i) => {
						if(pdt[payload.productId])
						{
							state.order.area[payload.areaId].splice(i, 1);
							state.order.area_dates[payload.areaId].splice(i, 1);
						}
					});
					if(payload.qty > 0){
						state.order.area[payload.areaId].push({
							[payload.productId]:payload.qty
						});
						state.order.area_dates[payload.areaId].push({
							[payload.productId]:payload.areaDate
						});
					}
				}

			}
		},
		modifyAreaCommentRequired (state, payload) {
			if(payload.required.length==0){
				Vue.delete(state.order.area_comments_required, payload.areaId)
			}else{
				Vue.set(state.order.area_comments_required, payload.areaId, payload.required)
			}
		},
		modifyRetGenCommentRequired (state, payload) {
			if(payload.required.length==0){
				Vue.delete(state.order.retgen_comments_required, payload.phaseId)
			}else{
				Vue.set(state.order.retgen_comments_required, payload.phaseId, payload.required)
			}
		},
		modifyRetGenProductComments (state, payload) {
			if(payload.comment==''){
				state.order.retgen_comments[payload.phaseId].forEach((pdt, i) => {
					if(pdt[payload.productId])
					{
						state.order.retgen_comments[payload.phaseId].splice(i, 1);
						if(!state.order.retgen_comments[payload.phaseId].length){
							state.order.retgen_comments = {};
						}
					}
				});

			}else{
				if(state.order.retgen_comments[payload.phaseId] == undefined)
				{
					Vue.set(state.order.retgen_comments, payload.phaseId, [{[payload.productId]:payload.comment }])
				}
				else 
				{
					state.order.retgen_comments[payload.phaseId].forEach((pdt, i) => {
						if(pdt[payload.productId])
						{
							state.order.retgen_comments[payload.phaseId].splice(i, 1);
						}
					});
					state.order.retgen_comments[payload.phaseId].push({
						[payload.productId]:payload.comment
					});
				}

			}
		},
		modifyAreaProductComments (state, payload) {
			if(payload.comment==''){
				state.order.area_comments[payload.areaId].forEach((pdt, i) => {
					if(pdt[payload.productId])
					{
						state.order.area_comments[payload.areaId].splice(i, 1);
						if(!state.order.area_comments[payload.areaId].length){
							state.order.area_comments = {};
						}
					}
				});

			}else{
				if(state.order.area_comments[payload.areaId] == undefined)
				{
					Vue.set(state.order.area_comments, payload.areaId, [{ [payload.productId]:payload.comment }])
				}
				else 
				{
					state.order.area_comments[payload.areaId].forEach((pdt, i) => {
						if(pdt[payload.productId])
						{
							state.order.area_comments[payload.areaId].splice(i, 1);
						}
					});
					state.order.area_comments[payload.areaId].push({
						[payload.productId]:payload.comment
					});
				}

			}
		},
		emptyStore(state) {
			state.order.area = {}
			state.order.area_comments = {}
			state.order.phase = {}
			state.order.carports = {}
			state.order.first_fix = {}
			state.order.wire = {}
			state.order.tools = {}
			state.order.final_fix = {}
			state.order.units = {}
			state.order.final_fix_general = {}
			state.order.common = {}
			state.order.area_files = {}
			state.order.specialarea = {}
		}
	},
	actions: {
		loadOrder ({ commit }, credentials) {
			//TODO: fetch here rather than in component? Maybe Maybe not!! below is fake, not implimented
			return $axios.post('XXXX', credentials)
				.then((response) => {
					commit('setArea', response.data.area_products)
					commit('setPhase', response.data.phase_products)
					// etc etc
				})
		}
	},
	getters: {
		getOrder ({ order }) {
			return order
		},
		getFirstFix ({ order }) {
			return order.first_fix
		},
		orderEmpty: ({ order })  => {
			let empty = true;
			for (var key in order) {
				if (order.hasOwnProperty(key)) {
					if(Object.keys(order[key]).length !== 0){
						return false;
					}
				}
			}
			return empty;
		},
		areaOrderCommentsRequired: ({ order })  => {
			if(Object.keys(order.area_comments_required).length == 0){
				return false
			}

			for (var key in order.area_comments_required) {
				if (order.area_comments_required.hasOwnProperty(key)) {
					for (var i = order.area_comments_required[key].length - 1; i >= 0; i--) {
						if(!order.area_comments.hasOwnProperty(key)) return true;
						let exists = order.area_comments[key].filter(comment => comment.hasOwnProperty(order.area_comments_required[key][i]));
						if(!exists.length) return true;
					}
				}
			}
			return false
		},
		RetGenOrderCommentsRequired: ({ order })  => {
			if(Object.keys(order.retgen_comments_required).length == 0){
				return false
			}

			for (var key in order.retgen_comments_required) {
				if (order.retgen_comments_required.hasOwnProperty(key)) {
					for (var i = order.retgen_comments_required[key].length - 1; i >= 0; i--) {
						if(!order.retgen_comments.hasOwnProperty(key)) return true;
						let exists = order.retgen_comments[key].filter(comment => comment.hasOwnProperty(order.retgen_comments_required[key][i]));
						if(!exists.length) return true;
					}
				}
			}
			return false
		},
		getAreaFiles: (state) => {
			return state.order.area_files;
		}
	}
}
